import client, { client2 } from "../auth/client";
import { UpdateSelectedSourcesRequest } from "../common/types";

export const createArticleSession = async () => {
  const res = await client.get(`/chat/create_session/`);
  return res.data;
}

export const getChatMessages = async (session_id: string) => {
  const res = await client.get(`/chat/get_chat_messages/${session_id}/`);
  return res.data;
}

export const getArticle = async (session_id: string) => {
  const res = await client.get(`/chat/get_article/${session_id}/`);
  return res.data;
}

export const getSourcesOptions = async (session_id: string) => {
  const res = await client.get(`/chat/get_user_options/${session_id}/`);
  return res.data;
}

export const chatGeneratedContent = async (
  session_id: string,
  reqBody: { query: string }
) => {
  const res = await client.post(`/chat/generate_article/${session_id}/`, reqBody);
  return res.data;
}

export const updateSelectedSources = async (
  session_id: string,
  reqBody: UpdateSelectedSourcesRequest
): Promise<any> => {
  const res = await client.patch(`/chat/update_user_options/${session_id}/`, reqBody);
  return res.data;
};

export const exportArticle = async (session_id: string, reqBody: {}) => {
  const res = await client.post(`/chat/export_article/${session_id}/`, reqBody, {
    responseType: "blob"
  });
  return res.data;
}

export const editArticleTitle = async (session_id: string, reqBody: { title: string }) => {
  const res = await client.post(`/chat/update_title/${session_id}/`, reqBody);
  return res.data;
}

export const getProjectMappings = async () => {
  const res = await client2.get("common/get_project_mappings/");
  return res.data;
};

export const updateProjectMappings = async (projectName: any) => {
  const response = await client2.post("common/update_project_mappings/", {
    project_name: projectName,
  });
  return response.data;
};

export const updateArticleStatus = async (
  session_id: string,
  reqBody: { status: string }
) => {
  const res = await client.patch(`/chat/update_article_status/${session_id}/`, reqBody);
  return res.data;
}

export const getArticleList = async () => {
  const res = await client.get(`/chat/get_dashboard_articles/`);
  return res.data;
}